import * as React from 'react';
export const postalSvg = React.forwardRef(function postalSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26.11 9.758a1 1 0 0 1 .228-.813c.194-.225.474-.352.772-.352H28c-.313-.76-.747-1.272-1.573-1.272-.45 0-.986.232-1.327.63-.49.573-.663 1.313-.543 2.056l1.422 8.59a3.375 3.375 0 0 1-.768 2.746 3.428 3.428 0 0 1-2.61 1.198h-2.106V7.603c0-1.129.925-2.046 2.064-2.046.777 0 1.483.427 1.837 1.118l1.401-.707A3.634 3.634 0 0 0 22.557 4c-2.006 0-3.638 1.619-3.638 3.605v3.497H4v13h10.913V28h1.573v-3.898h2.435V28h1.574v-3.898h2.107a5.016 5.016 0 0 0 3.81-1.747 4.917 4.917 0 0 0 1.122-4.008l-1.422-8.589h-.002ZM5.573 12.66h3.102v3.5H5.573v-3.5Zm.577 9.882 5.9-4.282 5.588 4.282H6.15Zm12.771-.985L13.37 17.3l5.552-4.032v8.289Zm3.634-14.749c.423 0 .766.34.766.76s-.343.759-.766.759a.762.762 0 0 1-.766-.76c0-.419.342-.759.766-.759Z',
      fill: '#6320EE',
    }),
  );
});
postalSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var postal = {
  category: 'brand',
  colorable: false,
  name: 'postal',
  svg: postalSvg,
};
